
export const home = {
  // Hero Section
  heroTitle: 'Changing the Future\nwith Cosmic Thinking',
  heroSubtitle: 'Innovative educational experience where exploratory learning leads to real competencies',
  heroDescription: 'Dr.ICAN Universal Warp: Propelling Children\'s Language Dimensions Forward. We provide future-oriented educational programs that develop students\' creative thinking and problem-solving skills through space science and technology.',
  heroButton: 'Start Super Kids Journey',
  
  // Why Space Section
  whySpaceTitle: 'Why Space Education?',
  whySpaceSubtitle: 'Space is the ultimate learning environment where all disciplines converge',
  whySpaceDescription: 'Through space education, students naturally learn mathematics, science, engineering, and technology integration. Space missions require complex problem-solving, teamwork, and creative thinking.',
  whySpaceFeature1Title: 'Integrated Learning',
  whySpaceFeature1Desc: 'Natural integration of STEM subjects',
  whySpaceFeature2Title: 'Problem Solving',
  whySpaceFeature2Desc: 'Development of creative solutions',
  whySpaceFeature3Title: 'Future Preparation',
  whySpaceFeature3Desc: 'Skills needed for the space age',
  
  // 스페이스 오리엔티어링 Learning Experience
  learningTitle: '스페이스 오리엔티어링 Learning Experience',
  learningSubtitle: 'Experiential learning through real space missions',
  learningDescription: 'Students participate in actual NASA missions and space exploration projects, experiencing real problem-solving processes.',
  
  // Competencies
  competenciesTitle: 'Core Competencies',
  competenciesSubtitle: 'Developing essential skills required by future society',
  competenciesDescription: 'We systematically develop the core competencies needed in the 4th industrial revolution era.',
  
  // Signature Projects
  projectsTitle: 'Signature Projects',
  projectsSubtitle: 'Project-based learning using real space technology',
  projectsDescription: 'Experience cutting-edge space technology through hands-on projects and develop practical skills.',
  
  // Curriculum
  curriculumTitle: 'Curriculum',
  curriculumSubtitle: 'Systematic and progressive learning process',
  curriculumDescription: 'A curriculum designed to systematically develop from basic concepts to advanced applications.',
  
  // Platonic Education
  platonicTitle: 'Platonic Education Approach',
  platonicSubtitle: 'Education that awakens the inner potential of students',
  platonicDescription: 'Based on Plato\'s educational philosophy, we believe that all knowledge exists within students and our role is to help them discover it.',
  
  // Studio Sound
  studioTitle: 'Studio Sound Experience',
  studioSubtitle: 'Professional audio technology learning',
  studioDescription: 'Learn professional sound recording and production technology through space communication systems.',
  
  // Noise Reduction
  noiseTitle: 'Advanced Noise Reduction',
  noiseSubtitle: 'AI-powered sound processing technology',
  noiseDescription: 'Experience cutting-edge noise reduction technology used in space communication.',
  
  // Featured Products
  featuredTitle: 'Featured Learning Materials',
  featuredSubtitle: 'Carefully selected educational materials for optimal learning effects',
  
  // Products Section
  productsTitle: 'Learning Programs',
  productsSubtitle: 'Diverse programs tailored to different age groups and levels',
  
  // Recommended
  recommendedTitle: 'Recommended Programs',
  recommendedSubtitle: 'Programs recommended by our education experts',
  
  // Blog
  blogTitle: 'Latest News & Insights',
  blogSubtitle: 'Stay updated with space education trends and success stories',
  
  // CTA Section
  ctaTitle: 'Start Your Journey to Space',
  ctaSubtitle: 'Apply for consultation now and experience exceptional education',
  ctaButton: 'Free Consultation',
  ctaSecondaryButton: 'View Programs',
  
  // Consultation Form
  consultationTitle: 'Consultation Request',
  consultationSubtitle: 'Our professional consultants will guide you through customized educational programs',
  
  // Preorder
  preorderTitle: 'Early Bird Special Offer',
  preorderSubtitle: 'Limited time offer for early adopters',
  preorderButton: 'Pre-order Now',
  
  // Roadmap
  roadmapTitle: 'Learning Roadmap',
  roadmapSubtitle: 'Step-by-step journey to space expertise',
  
  // Carousel
  carouselTitle: 'Success Stories',
  carouselSubtitle: 'Real achievements from our students',
  
  // Category
  categoryTitle: 'Program Categories',
  categorySubtitle: 'Choose the right program for your learning goals',
  
  // Product Cards
  productCardsTitle: 'Popular Programs',
  productCardsSubtitle: 'Most loved programs by students and parents',
  
  // Claim
  claimTitle: 'Join the Space Generation',
  claimSubtitle: 'Be part of the future space explorers',
  
  // Features
  featuresTitle: 'Key Features',
  featuresSubtitle: 'What makes our education special',
  feature1Title: 'Real Mission Experience',
  feature1Desc: 'Participate in actual space missions',
  feature2Title: 'Expert Instructors',
  feature2Desc: 'Learn from space industry professionals',
  feature3Title: 'Cutting-edge Technology',
  feature3Desc: 'Access to latest space technology',
  feature4Title: 'Global Community',
  feature4Desc: 'Connect with space enthusiasts worldwide',
  
  // Programs list
  satelliteDataLiteracy: 'Satellite Data Literacy',
  roverDesignSprint: 'Rover Design Sprint',
  spaceEconomySimulation: 'Space Economy Simulation',
  spaceStationEcosystem: 'Space Station Ecosystem',
  customCurriculum: 'Custom Curriculum',
  
  // Support list
  learningGuide: 'Learning Guide',
  parentReviews: 'Parent Reviews',
  faq: 'FAQ',
  technicalSupport: 'Technical Support',
  
  // Curriculum Section
  curriculumModuleTitle: 'Curriculum <span>Modules</span>',
  curriculumModuleSubtitle: 'Complete cosmic thinking through systematic step-by-step learning',
  
  // Module 1
  module1Title: 'Satellite Data Literacy',
  module1Subtitle: 'Satellite Data Literacy',
  module1Description: 'Analyze climate patterns with basic statistics and visualization',
  module1Duration: '4 weeks',
  module1Level: 'Beginner',
  module1Topic1: 'Satellite data collection',
  module1Topic2: 'Basic statistical analysis',
  module1Topic3: 'Data visualization',
  module1Topic4: 'Climate pattern interpretation',
  
  // Module 2
  module2Title: 'Rover Design Sprint',
  module2Subtitle: 'Rover Design Sprint',
  module2Description: 'Problem definition – Ideation – Prototype – Testing',
  module2Duration: '6 weeks',
  module2Level: 'Intermediate',
  module2Topic1: 'Problem definition',
  module2Topic2: 'Idea generation',
  module2Topic3: 'Prototype creation',
  module2Topic4: 'Performance testing',
  
  // Module 3
  module3Title: 'Space Economy Simulation',
  module3Subtitle: 'Space Economy Simulation',
  module3Description: 'Data modeling and storytelling pitch',
  module3Duration: '6 weeks',
  module3Level: 'Advanced',
  module3Topic1: 'Economic modeling',
  module3Topic2: 'Simulation design',
  module3Topic3: 'Data analysis',
  module3Topic4: 'Business pitch',
  
  // Module buttons
  moduleDetailButton: 'View Module Details',
  
  // Learning Path
  learningPathTitle: 'Learning Path',
  learningPathSubtitle: 'We provide customized learning paths tailored to individual levels and interests',
  learningPathStep1Title: 'Level Assessment',
  learningPathStep1Desc: 'Pre-assessment of language, math, and digital competencies',
  learningPathStep2Title: 'Customized Path',
  learningPathStep2Desc: 'Establish learning plan tailored to individual level',
  learningPathStep3Title: 'Achievement Certification',
  learningPathStep3Desc: 'Module completion certificates and portfolio',
  
  // Navigation
  navHome: 'Home',
  navPrograms: 'Programs',
  navAbout: 'About',
  navContact: 'Contact',
  navShop: 'Shop',

  // Common buttons
  learnMore: 'Learn More',
  getStarted: 'Get Started',
  readMore: 'Read More',
  viewAll: 'View All',
  apply: 'Apply',
  download: 'Download',

  // EDUSPACE Curriculum Section
  eduspaceBadge: 'EDUSPACE 8-Week Program',
  eduspace8WeekTitle: '8-Week',
  eduspaceJourneyTitle: 'Space Exploration Journey',
  eduspaceSubtitle: 'Systematic problem-solving program for elementary grades 4-5',

  // Weekly highlights
  week1: 'Earth Science',
  week1Desc: 'Earth systems and climate pattern exploration',
  week2: 'The Moon',
  week2Desc: 'Lunar phases and Moon base design',
  week3: 'Space Rovers',
  week3Desc: 'Mars rover design and construction',
  week4: 'Mars Exploration',
  week4Desc: 'Mars mission planning and survival strategies',
  week5: 'Life in Space',
  week5Desc: 'Space life system design',
  week6: 'Stars and Galaxies',
  week6Desc: 'Stellar lifecycles and cosmic structure exploration',
  week7: 'AI in Space',
  week7Desc: 'Space data analysis with AI',
  week8: 'Final Project',
  week8Desc: 'Comprehensive space mission presentation',

  // Program features
  handsOnTitle: 'Hands-On Learning',
  handsOnDesc: 'Experiential classes where students create and experiment daily',
  weeklyStructureTitle: '5-Day Structure',
  weeklyStructureDesc: 'Systematic Mon-Fri weekly learning program',
  customizedTitle: 'Customized Learning',
  customizedDesc: 'Optimized difficulty level for elementary grades 4-5',

  // Daily activities
  mondayShort: 'Monday',
  mondayActivity: 'Study Skills &\nQuestioning',
  tuesdayShort: 'Tuesday',
  tuesdayActivity: 'Orienteering &\nResearch',
  wednesdayShort: 'Wednesday',
  wednesdayActivity: 'Space &\nProblem Solving',
  thursdayShort: 'Thursday',
  thursdayActivity: 'Tech &\nProduction',
  fridayShort: 'Friday',
  fridayActivity: 'Writing &\nCommunication',

  viewFullCurriculum: 'View Full Curriculum'
};
